import createSimpleValidator from './createSimpleValidator';

const errorString = 'Vous devez entrer un code postal valide (5 chiffres).';
const checkIsZipCode = createSimpleValidator(
    (value) => /^[0-9]{5}$/.test(value),
    errorString,
);

export default checkIsZipCode;
